export default __webpack_public_path__ + "static/Dallas-a40346e65943202f15f141a5b8affdb2.webp";